// The words an organization files its assets under, and the words on one asset.

import { api, withQuery } from '../client'
import type { components, operations } from '../schema'

export type TagEntry = components['schemas']['TagEntry']
export type AssetTagEntry = components['schemas']['AssetTagEntry']
export type CreateTagRequest = components['schemas']['CreateTagRequest']
export type SetAssetTagsRequest = components['schemas']['SetAssetTagsRequest']
export type TagsQuery = NonNullable<operations['tags_list']['parameters']['query']>

/**
 * The tags a picker offers, most used first and then by name. Hidden tags are not among them,
 * though an asset that carries one still shows it.
 */
export function listTags(query: TagsQuery = {}, signal?: AbortSignal): Promise<TagEntry[]> {
  return api.get<TagEntry[]>(withQuery('/tags', query), undefined, signal)
}

/**
 * Coin a word on a workspace's shelf, with an `asset_count` of zero. 409 when that handle already
 * names a live tag of the same scope.
 */
export function createTag(request: CreateTagRequest): Promise<TagEntry> {
  return api.post<TagEntry>('/tags', request)
}

/** Retire a word, with every application of it. */
export function deleteTag(tagId: string): Promise<void> {
  return api.del<void>(`/tags/${encodeURIComponent(tagId)}`)
}

/**
 * File one asset under exactly these tags, and answer its tags as a read of the asset now would.
 * A diff rather than a truncate: a word already on it keeps the day it was applied.
 */
export function setAssetTags(assetId: string, request: SetAssetTagsRequest): Promise<AssetTagEntry[]> {
  return api.put<AssetTagEntry[]>(`/assets/${encodeURIComponent(assetId)}/tags`, request)
}
